export enum SyncMode {
  none = 'none',
  offline = 'offline',
  online = 'online',
  mixed = 'mixed',
}
